/**
 * Created by vladislav on 1/26/2024
 */

const OKLogic = function () {
    PlatformLogic.call(this);

    if (!connector.info.isMobile) {
        connector.platform.whenConnected(this.onResize.bind(this));
    }
};

OKLogic.prototype = Object.create(PlatformLogic.prototype);
OKLogic.prototype.constructor = OKLogic;

OKLogic.prototype.onResize = function () {
    connector.platform.getPlugin().listeners.getPageInfo = function (result, data) {
        let height;
        try {
            height = JSON.parse(data).innerHeight;
        } catch (e) {
            height = window && window.innerHeight || document && document.body && document.body.clientHeight || 800;
        }
        let h = height - 75;
        if (h < 600) {
            h = 600;
        }
        FAPI.UI.setWindowSize(760, h);
        cleverapps.resolution.setupDesignResolution(cc.size(cc.view.getFrameSize().width, h));
    };

    [0, 5, 10, 20, 60].forEach((timeout) => {
        setTimeout(FAPI.UI.getPageInfo, timeout * 1000);
    });
};

OKLogic.prototype.reportStatus = function (event, status) {
    if (!connector.platform.isConnected()) {
        return;
    }

    console.log("setStatus", event, status);
    FAPI.Client.call({
        method: "sdk.setStatus",
        event,
        status
    }, function (code, data, error) {
        // eslint-disable-next-line prefer-rest-params
        console.log("sdk.setStatus response", JSON.stringify(arguments));

        let logEvent = "set_status_ok";
        if (code !== "ok") {
            logEvent = "set_status_error";

            if (error && (error.error_msg || error.error_code)) {
                cleverapps.throwAsync(`sdk.setStatus event: '${event}' status: '${status}' error: ${JSON.stringify(error)}`);
            }
        }
        cleverapps.metrics.logEvent(logEvent);
    });
};

OKLogic.prototype.getPushCode = function () {
    const rParams = FAPI.Util.getRequestParameters();

    const pushCode = cleverapps.getRequestParameters(`?${rParams.custom_args}`).push_code;
    if (pushCode) {
        return pushCode;
    }
    const push = Object.values(PUSHES).find((push) => String(push.id) === String(rParams.custom_args));
    if (push) {
        return push.code;
    }
};

OKLogic.prototype.logPushes = function () {
    const pushCode = this.getPushCode();
    if (pushCode) {
        this.logClickEvent(pushCode);
    }
};
